export var VERSION = '2.2.0';
//# sourceMappingURL=version.js.map